import { NAMES } from '../actions/requests-counter';

export const requestsCounter = (state = 0, action) => {
  switch (action.type) {
    case NAMES.REQUEST_INCREMENT:
      return state + 1;
    case NAMES.REQUEST_DECREMENT:
      return state - 1;
    default:
      return state;
  }
};
